export enum ResultsViews {
  chart = 0,
  grid = 1
}
